require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./data-visualization-data-visualization-with-d-3-use-dynamic-scales.json") })
        }
      }, "path---data-visualization-data-visualization-with-d-3-use-dynamic-scales");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---data-visualization-data-visualization-with-d-3-use-dynamic-scales!./.cache/json/data-visualization-data-visualization-with-d-3-use-dynamic-scales.json
// module id = 1978
// module chunks = 231608221292675